<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Impersonated User</cs-header-title>
</cs-header>

<cs-content>
  @if (impersonationUserAuth !== null) {
    <cs-item-list>
      <cs-item>
        <cs-label>{{ impersonationUserAuth.email }}</cs-label>
      </cs-item>
    </cs-item-list>
  }
</cs-content>

@if (impersonationUserAuth !== null) {
  <cs-page-action-buttons>
    <cs-button primary medium [label]="'Stop Impersonating' | untranslated" (click)="onStopImpersonatingButtonClicked()"></cs-button>
  </cs-page-action-buttons>
}